import ContentSummary from "tds/contentSummary";

export { ContentSummary };

customElements.define(
  "tds-content-summary",
  ContentSummary.CustomElementConstructor
);
